export default [
  '#68442c',
  '#86d641',
  '#a775db',
  '#df5ac3',
  '#46bee8',
  '#63c99a',
  '#19937c',
  '#ed544c',
  '#ff931e',
  '#107ec1',
  '#48e1ed',
  '#743da5',
  '#f9d128',
  '#ff931e',
  '#9e4b39',
  '#b51c98',
  '#b20202',
  '#bf8a66',
  '#2c3f50',
  '#441f62',
  '#0c5b4c',
  '#391401',
  '#27ae61',
  '#ef7bef',
];
